import { FiltersTypes } from "@common/types/filters/general";
import { FinancialDocumentColumn } from "@common/types/views/financialDocumentViews";
import { ViewDensity, ViewType } from "@common/types/views/views";
import { financialDocumentsCloseTemplateViewConfigSchema } from "@common/schemas/close-template-task-view-config.schema";

function financialDocumentsTaskColumns() {
    return [
        {
            id: FinancialDocumentColumn.NAME,
            options: { pin: "left" as const },
        },
        { id: FinancialDocumentColumn.UPLOAD_DATE },
        { id: FinancialDocumentColumn.DOCUMENT_CATEGORY },
        { id: FinancialDocumentColumn.COUNTERPARTY },
        { id: FinancialDocumentColumn.PERIOD },
        { id: FinancialDocumentColumn.ENTITY },
        { id: FinancialDocumentColumn.STATUS },
    ];
}

export interface CreateFinancialDocumentsViewConfigParams {
    filters?: FiltersTypes;
    columns?: ReturnType<typeof financialDocumentsTaskColumns>;
}

/**
 * Default view for a FINANCIAL_DOCUMENTS task (template, workspace drawer and
 * bulk selection). Selection and bulk actions are on so the task body can act
 * on rows; the creation preview turns them off locally. The view type is the
 * shared financial document type: dispatch is keyed by TaskType, never by view
 * type, because DOCUMENT_RETRIEVAL tasks use the same view type.
 */
export function createFinancialDocumentsViewConfig({
    filters = {},
    columns,
}: CreateFinancialDocumentsViewConfigParams = {}) {
    return financialDocumentsCloseTemplateViewConfigSchema.parse({
        type: ViewType.FINANCIAL_DOCUMENT,
        columns: columns ?? financialDocumentsTaskColumns(),
        filters,
        options: {
            selection: true,
            bulkActions: true,
            density: ViewDensity.MD,
        },
    });
}
